import store  from '../../store'
import Notifications from 'react-notification-system-redux';

function success(message) {
    store.dispatch(
        Notifications.success({
            title: message,
            position: 'tr',
            autoDismiss: 5})
    );
}

function error(message) {
    store.dispatch(
        Notifications.error({
            title: message,
            position: 'tr',
            autoDismiss: 5})
    );
}

function info(message) {
    store.dispatch(
        Notifications.info({
            dismissible: 'click',
            message: message,
            position: 'tc',
            autoDismiss: 0})
    );
}

export default { success, error, info}
